import type { FC, PropsWithChildren } from 'react';
import { useCallback } from 'react';
import type { LayoutChangeEvent } from 'react-native';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import { MEIN_ORT_LOCATION_BAR_HEIGHT } from '@/features/mein-ort/components/MeinOrtLocationBar';
import { useMeinOrtScroll } from '@/features/mein-ort/components/MeinOrtScrollContext';
import { isNative } from '@/shared/utils/platform';

export const MeinOrtHeader: FC<PropsWithChildren> = ({ children }) => {
  const insets = useSafeAreaInsets();
  const topInset = isNative ? insets.top : 0;
  const { scrollY, setHeaderHeight } = useMeinOrtScroll();

  const headerStyle = useAnimatedStyle(() => {
    'worklet';
    return {
      transform: [
        {
          translateY: -Math.min(
            Math.max(scrollY.value, 0),
            MEIN_ORT_LOCATION_BAR_HEIGHT
          )
        }
      ]
    };
  });

  const onLayout = useCallback(
    (event: LayoutChangeEvent) => {
      const height = event.nativeEvent.layout.height;
      setHeaderHeight((current) => Math.max(current, height));
    },
    [setHeaderHeight]
  );

  return (
    <Animated.View
      style={[styles.header, { top: topInset }, headerStyle]}
      onLayout={onLayout}
    >
      {children}
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  header: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 2
  }
});
